import React, { useEffect, useState } from 'react'
import '../../assets/css/components/Display/Modal.css'
import Modal from './Modal'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Select from '../Inputs/Select'
import InputText from '../Inputs/InputText'
import SelectOfCategories from '../Inputs/SelectOfCategories'
import Button from '../General/Button'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

const ModalInventorySearch: React.FC<any> = ({
  modalSearch,
  onCloseModalSearch,
  onSubmitInventory,
}) => {
  // const defaultLClasses = 'absolute bg-white default-modal rounded-xl';

  const searchForm = useForm()

  const [docs] = useState<{ value: string; text: string }[]>([
    {
      value: 'code',
      text: 'Código',
    },
    {
      value: 'keywords',
      text: 'Palabras Claves',
    },
    {
      value: 'category',
      text: 'Categoria',
    },
  ])

  const [typeSelected, setTypeSelected] = useState<string>('')

  const [categoriesValues, setCategoriesValues] = useState<any[]>([])

  const [subCategories, setSubCategories] = useState<any>([])

  const categories = useSelector((state: RootState) => state.ctgr.categories)

  useEffect(() => {
    setCategoriesValues(
      categories
        .filter((category) => category.children.length !== 0)
        .map((category) => ({ value: category.id, text: category.name }))
    )
  }, [categories])

  return (
    <>
      <Modal
        display={modalSearch}
        // modalClasses="w-2/5 py-4 px-8"
        onAccept={() => null}
        onClose={() => onCloseModalSearch()}
      >
        <div>
          <Form
            form={searchForm}
            classes={`gap-x-6 gap-y-2`}
            onSubmit={(values) =>
              onSubmitInventory({ ...values, typeSelected })
            }
          >
            <h2 className="col-span-12 text-primary-900 font-bold dark:text-white mb-3">
              Buscar Articulos
            </h2>

            <FormItem
              name="code"
              defaultValue={docs[0]}
              classes="lg:col-span-4 col-span-12"
            >
              <Select
                options={docs}
                setSelectedHelper={(values) => setTypeSelected(values.value)}
                label="Tipo"
              />
            </FormItem>

            {typeSelected === 'keywords' && (
              <FormItem name="name" classes="lg:col-span-8 col-span-12">
                <InputText small label="Palabras clave" maxLength={80} />
              </FormItem>
            )}

            {typeSelected === 'code' && (
              <FormItem name="code" classes="lg:col-span-8 col-span-12">
                <InputText small label="Codigo" maxLength={80} />
              </FormItem>
            )}

            {typeSelected === 'category' && (
              <>
                <FormItem
                  name="category"
                  defaultValue={categoriesValues[0]}
                  classes="lg:col-span-4 col-span-12"
                >
                  <SelectOfCategories
                    options={categoriesValues}
                    setSelectedHelper={(values) => {
                      setSubCategories([
                        { text: 'Todos', value: '0' },
                        ...(categories
                          .find((category) => category?.id === values.value)
                          ?.children.map((sub) => ({
                            text: sub.name,
                            value: sub.id,
                          })) as any[]),
                      ])
                    }}
                    label="Categorias"
                  />
                </FormItem>

                <FormItem
                  name="subCategory"
                  defaultValue={subCategories[0]}
                  classes="lg:col-span-4 col-span-12"
                >
                  <SelectOfCategories
                    options={subCategories}
                    setSelectedHelper={(values) =>
                      console.log('values', values)
                    }
                    label="Sub Categorias"
                  />
                </FormItem>
              </>
            )}

            <div className="col-start-4 col-span-9 flex space-x-2 mt-4 px-1 mt-3">
              <Button
                type="outline"
                classes="w-1/2 mr-4"
                onClick={() => onCloseModalSearch()}
                htmlType="button"
              >
                Cancelar
              </Button>

              <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
                Buscar
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  )
}

export default ModalInventorySearch
